import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { UserService, PlatoService } from 'src/app/core';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
  userName;
  items: MenuItem[];
  itemsUsr: MenuItem[];
  usuarioLogueado;
  permisosAdmin: boolean = false;
  permisosLunch: boolean = false;
  nombreUser;
  constructor(
    private router: Router,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.userName = JSON.parse(sessionStorage.getItem('user')).user.username;
    this.usuarioLogueado = this.userService.getUser();
    this.nombreUser = this.usuarioLogueado.user.nombre;
    this.checkPermissions();
    this.itemsUsr = [
      {
        label: 'Perfil',
        icon: 'pi pi-user',
        command: (event) => {
          this.router.navigate(['intranet/user/perfil'])
        }
      },
      {
        label: 'Cerrar Sesion', icon: 'fa fa-sign-out', command: (event) => {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['']);
        }
      }
    ];
    this.items = [
      {
        label: '',
        styleClass: 'logo_navbar',
        command: (event) => {
          this.router.navigate(['intranet/novedades/home'])
        }
      },
      {
        label: 'Reservianos',
        styleClass: 'menu_options',
        items: [
          {
            label: 'Usuarios',
            icon: 'pi pi-users',
            command: () => {
              this.router.navigate(['/intranet/backOffice/users']);
            }
          },

        ],
        visible: this.permisosAdmin
      },
      {
        label: 'Reportes',
        styleClass: 'menu_options',
        items: [
          {
            label: 'Usuario',
            icon: 'pi pi-folder',
            command: () => {
              this.router.navigate(['intranet/reportes/usuario']);
            }
          },
          {
            label: 'Tecnología',
            icon: 'pi pi-folder',
            command: () => {
              this.router.navigate(['intranet/reportes/tecnologia']);
            }
          },
        ],
        visible: this.permisosAdmin
      },
      // {
      //   label: 'Tecnologías',
      //   styleClass: 'menu_options',
      //   items: [
      //     // {
      //     //   label: 'Tecnologías',
      //     //   icon: 'pi pi-list',
      //     //   command: () => {
      //     //     this.router.navigate(['intranet/novedades/home']);
      //     //   }
      //     // },
      //   ],
      //   visible: this.permisosAdmin
      // },
      {
        label: 'Descripciones de puestos',
        styleClass: 'menu_options',
        items: [
          // {
          //   label: 'Empresas',
          //   icon: 'pi pi-globe',
          //   command: () => {
          //     this.router.navigate(['intranet/novedades/home']);
          //   }
          // },
          // {
          //   label: 'Proyectos',
          //   icon: 'pi pi-briefcase',
          //   command: () => {
          //     this.router.navigate(['intranet/novedades/home']);
          //   }
          // },
          {
            label: 'Puestos',
            icon: 'pi pi-sitemap',
            command: () => {
              this.router.navigate(['intranet/puestos/puesto']);
            }
          },
        ],
        visible: this.permisosAdmin
      },
      {
        label: 'Evaluaciones',
        styleClass: 'menu_options',
        items: this.evaluacionesMenu(),
      }
    ];
  }

  evaluacionesMenu() {
    const menu = [
      {
        label: 'Realizar Autoevaluación técnica',
        icon: 'pi pi-user-edit',
        command: () => {
          this.router.navigate(['intranet/evaluaciones/actualizar']);
        }
      },
      // {
      //   label: 'Histórico',
      //   icon: 'pi pi-copy',
      //   command: () => {
      //     this.router.navigate(['intranet/novedades/home']);
      //   }
      // },
    ]

    return this.permisosAdmin
      ? [ ...menu,
        {
          label: 'Asignar',
          icon: 'pi pi-user-plus',
          command: () => { this.router.navigate(['intranet/evaluaciones/asignar']) }
        } ] : menu;
  }

  checkPermissions() {
    this.usuarioLogueado.user.roles.forEach(permiso => {
      if (permiso.role == "ADMIN") {
        this.permisosAdmin = true;
      }
      if (permiso.role == "LUNCH") {
        this.permisosLunch = true;
      }
    });
  }
}